// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"567e7afb","300":"c84dd104","493":"1ba2ccf1","964":"31ffaab5"}[chunkId] + ".ab98a889e3f3.chunk.css";
};